export default "__VITE_ASSET__1bb8dd26__"